import loadable from '@loadable/component';

export const namespace = 'canalplus.block.selfcare.disney_service';
export const Component = loadable(
  () => import('./containers/DisneyServiceContainer')
);
export { default as propsFormatter } from './propsFormatter';
